import React from 'react';

import cx from 'classnames';
import CSSModule from 'react-css-modules';
import Switch from 'react-switch';

import styles from './FormSwitch.module.scss';

// export const FormSwitch = ({
//   checked,
//   onChange,
//   label,
//   readOnly,
//   ...props
// }) => {
//   return (
//     <div
//       styleName="form-switch-container"
//       className="d-flex align-items-center"
//     >
//       <label className="mb-0 mr-5">{label}</label>
//       <Switch
//         className={cx({ 'checked-switch-bg': !!checked })}
//         onChange={onChange}
//         checked={!!checked}
//         uncheckedIcon={false}
//         checkedIcon={false}
//         readOnly={readOnly}
//         {...props}
//       />
//     </div>
//   );
// };
// export const FormSwitch = ({ input, checked, onChange, label, readOnly, ...props }) => {
//   const isChecked = !!input.value || checked;

//   return (
//     <div
//       styleName="form-switch-container"
//       className={`d-flex align-items-center ${isChecked ? 'checked-switch-bg' : ''}`}
//     >
//       <label className="mb-0 mr-5">{label}</label>
//       <Switch
//         onChange={input.onChange || onChange}
//         checked={isChecked || checked}
//         uncheckedIcon={false}
//         checkedIcon={false}
//         readOnly={readOnly}
//         {...props}
//       />
//     </div>
//   );
// };

export const FormSwitch = ({
  input,
  checked,
  onChange,
  label,
  readOnly,
  ...props
}) => {
  const isFinalForm = !!input;

  const isChecked = isFinalForm ? !!input.value : !!checked;
  const handleChange = isFinalForm ? input.onChange : onChange;

  return (
    <div
      styleName="form-switch-container"
      className={`d-flex align-items-center ${isChecked ? 'checked-switch-bg' : ''}`}
    >
      <label className="mb-0 mx-1">{label}</label>
      <Switch
        onChange={handleChange}
        checked={isChecked}
        uncheckedIcon={false}
        checkedIcon={false}
        readOnly={readOnly}
        {...props}
      />
    </div>
  );
};




export default CSSModule(FormSwitch, styles);
